export default {
  importLeadList: [],
  isLoading: false
};
